export default {"src":"/_next/static/media/networking.726983f9.svg","height":21,"width":20};